import styled from 'styled-components'

export const IconWrapper = styled.div`
	flex-shrink: 0;
`
